"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteAPIVersion = void 0;
var auth_suite_headers_1 = require("./auth-suite-headers");
Object.defineProperty(exports, "AuthSuiteAPIVersion", { enumerable: true, get: function () { return auth_suite_headers_1.AuthSuiteAPIVersion; } });
